import { AvvirEvent } from "type_aliases";

export type ProcoreRfiAssigneesLoadedEvent = AvvirEvent<typeof PROCORE_RFI_ASSIGNEES_LOADED, any>

const procoreRfiAssigneesLoaded = (procoreAssignees): ProcoreRfiAssigneesLoadedEvent => ({
  type: PROCORE_RFI_ASSIGNEES_LOADED,
  payload: procoreAssignees
});

export const PROCORE_RFI_ASSIGNEES_LOADED = "procore_rfi_assignees_loaded";

export default procoreRfiAssigneesLoaded;
